import api from '../../../services/api';

export interface OrderProductPayload {
  id?: string;
  productVariantId?: string | null;
  name: string;
  quantity: number;
  saleUnit?: 'pcs' | 'm2' | 'm3';
  unitPrice?: number;
  currency?: string;
  unit: string;
  width?: number;
  height?: number;
  length?: number;
  thickness?: number;
  description?: string;
  cnCode?: string;
  netWeight?: number;
  grossWeight?: number;
  countryOfOrigin?: string;
}

export async function saveOrderProducts(
  orderId: string,
  products: OrderProductPayload[],
  currency?: string
): Promise<void> {
  await api.put(`/orders/${orderId}/products`, { products, currency });
}
